<template>
  <div class="dialog-mask" v-show="isShow">
    <div class="dialog" v-move="'.title'">
      <div class="title" ref="titleBox">
        {{title}}
        <!-- <i class="el-icon-close" @click="cancel()" v-show="ischa"></i> -->
        <img class="ic-close" src="@/assets/img/home/cha.png" @click="cancel()" v-show="ischa">
      </div>
      <div class="content-box">
        <div class="content" :class="{ 'content-exist_btn': isbtn, }">
          <slot></slot>
        </div>
        <div class="bottom-box" v-show="isbtn">
          <button class="sub" :style="{ background: val1color }" @click="save()" v-show="isbtn === true || isbtn == 'save'">{{val1}}</button>
          <button class="cel" :style="{ background: val2color }" @click="cancel()" v-show="isbtn === true || isbtn == 'cancel'">{{val2}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      isShow: this.show,
    };
  },
  props: {
    title: {
      type: String,
      default: "默认标题",
    },
    show: {
      type: Boolean,
      default: false,
    },
    isbtn: {
      type: [ Boolean, String ],
      default: true,
    },
    ischa: {
      type: Boolean,
      default: false,
    },
    val1: {
      type: String,
      default: "保存",
    },
    val2: {
      type: String,
      default: "取消",
    },
    val1color: {
      type: String,
      default: "",
    },
    val2color: {
      type: String,
      default: "",
    },
  },
  mounted () {
    // 拖动前关闭所有el-select-dropdown
    let mouseDown = new MouseEvent('mousedown', {
      'view': window,
      'bubbles': true,
      'cancelable': true
    });
    let mouseUp = new MouseEvent('mouseup', {
      'view': window,
      'bubbles': true,
      'cancelable': true
    });
    let CloseDropdown = ()=>{
      document.dispatchEvent(mouseDown);
      document.dispatchEvent(mouseUp);
    }
    this.$refs.titleBox.addEventListener('mousedown', CloseDropdown);
    this.$refs.titleBox.addEventListener('touchstart', CloseDropdown);
  },
  methods: {
    cancel() {
      this.$emit("cancel", this.show);
    },
    save() {
      this.$emit("save");
    },
  },
  watch: {
    show(newV) {
      this.isShow = newV;
      // newV ? dMask.show() : dMask.hide()
    },
  },
};
</script>

<style lang='less' scoped>
.dialog-mask {
  position: fixed;
  z-index: 100;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: #00000020;
}
.dialog {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 101;
  min-width: 350px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.3);
  box-sizing: border-box;
  .title {
    height: 50px;
    background: #3831ff;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    .el-icon-close {
      position: absolute;
      background: #00b7ee;
      width: 24px;
      height: 24px;
      line-height: 24px;
      border-radius: 50%;
      text-align: center;
      right: 15px;
      top: 12px;
      cursor: pointer;
    }
    .ic-close {
      position: absolute;
      background: #00b7ee;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      right: 15px;
      top: 12px;
      cursor: pointer;
    }
  }
  .content-box {
    height: ~"calc(100% - 50px)";
    box-sizing: border-box;
    background: #fff;
    .content {
      height: 100%;
      box-sizing: border-box;
    }
    .content-exist_btn {
      height: ~"calc(100% - 75px)";
    }
    button {
      width: 80px;
      height: 40px;
      // padding: 0 20px;
      border: 0;
      color: #fff;
      border-radius: 6px;
      font-size: 16px;
      cursor: pointer;
    }
    .bottom-box {
      text-align: center;
      // height: 84px;
      // line-height: 84px;
      padding: 15px 0 15px;
      .sub {
        background: #3170ff;
        margin-right: 30px;
      }
      .cel {
        background: #efbc00;
      }
    }
  }
  /deep/ .el-select {
    display: inline-block !important;
    .el-select-dropdown {
      position: absolute !important;
      top: auto !important;
      left: auto !important;
    }
  }
}
</style>